import { useMemo } from 'react';

import { PeriodTypeSVC } from '../types';

import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { GridFilterItem } from '@mui/x-data-grid-pro';

export const useGetFilterInitialState = (): GridInitialStatePro => {
  return useMemo(() => {
    return {
      filter: {
        filterModel: {
          items: [
            {
              field: 'periodTypeSvc',
              operator: 'is',
              value: PeriodTypeSVC.m as PeriodTypeSVC
            }
          ] as GridFilterItem[]
        }
      }
    };
  }, []);
};
